import { FC } from 'react';
import styles from './index.module.scss';

/**
 * チェックマークバルーンコンポーネント
 */
export const CheckMarkBalloon: FC = () => {
  return (
    <div className={styles['jobSearchDetail-checkMarkBalloon']}>
      <span className={styles['jobSearchDetail-checkMarkBalloon__text']}>
        Check!
      </span>
    </div>
  );
};
